/**
 * Idempotency key generator.
 *
 * Use one per resource-create attempt: if a user double-clicks "Submit", or
 * the network blips between request and response, the second call carries
 * the same key and the backend de-duplicates. We never reuse keys across
 * different intents.
 *
 * Cryptographically random (crypto.randomUUID is available in all modern
 * browsers; vite supports them).
 */
export function newIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
    return crypto.randomUUID()
  }
  // Fallback if running in an exotic test env.
  return `idem-${Date.now()}-${Math.random().toString(36).slice(2)}`
}
